module.exports = __webpack_public_path__ + "static/img/fire_card@2x.6be6ca23.png";